// Analytics related to the Wix Websites product page
import { trackNavigationEvent, analyticsDataRegistry, trackPromotionEvent } from '@vp/digital-tracking-lib-ubik'
import { useEffect, useRef } from 'react'

const { wixWebsites, wixMySites, wixPlansBusiness, wixDomains, diwyProductPage, logoMakerProductPage, wixPlansWebsites } = analyticsDataRegistry

const MAIN_HERO_LABEL = 'Content:Main Hero'
const SECOND_HERO_LABEL = 'Content:Second Hero'
const PLAN_DETAILS_LABEL = 'Content:Plan Details'
const TEMPLATES_LABEL = 'Content:Templates'
const SEO_LABEL = 'Content: Get found on Google'
const THIRD_HERO_LABEL = 'Content:Third Hero'
const FOURTH_HERO_LABEL = 'Content:Fourth Hero'
const FREE_WEBSITES_SECTION_LABEL = 'Content:Free Websites Section'
const TEMPLATES_BUILT_FOR_EVERY_INDUSTRY_LABEL = 'Content:Templates built for every industry'
const NAVIGATION_TABS_LABEL = 'Content:Navigation Tabs'
const WIX_UPGRADE_SECTION_LABEL = 'Content:Wix Upgrade Section'
const TAKE_YOUR_BUSINESS_FURTHER_LABEL = 'Content:Take Your Business Further'
const IDEAS_AND_ADVICE_LABEL = 'Content:Ideas and Advice'
const WEBSITE_PRICING_LABEL = 'Content:Website Pricing Section'
const PLANS_AND_PRICING_DETAILS_LABEL = 'Content:Plans & Pricing Details'

export const GET_STARTED_CTA_DETAIL = 'Get Started'
export const UPGRADE_CTA_DETAIL = 'Upgrade my website'

export const VIEW_SIMILAR_CTA_DETAIL = 'View Similar'
export const EDIT_THIS_TEMPLATE_CTA_DETAIL = 'Edit this template'
export const START_CREATING_CTA_DETAIL = 'Start Creating'
export const READ_MORE_CTA_DETAIL = 'Read more'
export const UPGRADE_WEBSITE_CTA_DETAIL = 'Upgrade My Website'

export const PLANS_CTA_DETAIL = 'See Premium Plans'
const FIND_OUT_MORE_DETAILS = 'Find out more'
const VIEW_MORE_PLAN_DETAILS = 'View More plan details'
export const TENANT_TRACKING = 'vistaprint'

// For enabling better QM Tracking
// Refer for detail: https://vistaprint.atlassian.net/wiki/spaces/GA/pages/2354546498/Phase+1+-+Vista+x+WIX+Partnership#Tracking-for-QM
export const MAIN_HERO_DATA_SECTION_LABEL = wixWebsites?.pageSection + ':' + MAIN_HERO_LABEL
export const SECOND_HERO_DATA_SECTION_LABEL = wixWebsites?.pageSection + ':' + SECOND_HERO_LABEL
export const PLAN_DETAILS_DATA_SECTION_LABEL = wixWebsites?.pageSection + ':' + PLAN_DETAILS_LABEL
export const TEMPLATES_DATA_SECTION_LABEL = wixWebsites?.pageSection + ':' + TEMPLATES_LABEL
export const SEO_DATA_SECTION_LABEL = wixWebsites?.pageSection + ':' + SEO_LABEL
export const THIRD_HERO_DATA_SECTION_LABEL = wixWebsites?.pageSection + ':' + THIRD_HERO_LABEL
export const FOURTH_HERO_DATA_SECTION_LABEL = wixWebsites?.pageSection + ':' + FOURTH_HERO_LABEL
export const FREE_WEBSITES_SECTION_DATA_SECTION_LABEL = wixWebsites?.pageSection + ':' + FREE_WEBSITES_SECTION_LABEL
export const TEMPLATES_BUILT_FOR_EVERY_INDUSTRY_DATA_SECTION_LABEL = wixWebsites?.pageSection + ':' + TEMPLATES_BUILT_FOR_EVERY_INDUSTRY_LABEL
export const NAVIGATION_TABS_DATA_SECTION_LABEL = wixWebsites?.pageSection + ':' + NAVIGATION_TABS_LABEL
export const TAKE_YOUR_BUSINESS_FURTHER__DATA_SECTION_LABEL = wixWebsites?.pageSection + TAKE_YOUR_BUSINESS_FURTHER_LABEL
export const IDEAS_AND_ADVICE__DATA_SECTION_LABEL = wixWebsites?.pageSection + IDEAS_AND_ADVICE_LABEL
export const WIX_UPGRADE_DATA_SECTION_LABEL = wixWebsites?.pageSection + ':' + WIX_UPGRADE_SECTION_LABEL

enum WebsitesPageZones {
  MainHero = 'Main Hero',
  PlanDetails = 'Plan Details',
  Templates = 'Templates',
  SecondHero = 'Second Hero',
  ThirdHero = 'ThirdHero',
  FourthHero = 'FourthHero',
  FreeWebsitesSection = 'Free Websites Section',
  TemplatesBuiltForEveryIndustry = 'Templates built for every Industry Section',
  SeoSection = 'Get found on Google — without being an SEO expert',
  NavigationTabs = 'Navigation Tabs',
  TakeYourBusinessFurther = 'Take Your Business Further Section',
  IdeasAndAdvice = 'Ideas and Advice Section',
  WebsitePricing = 'Website Pricing Section',
}

const NAVIGATION_CLICKED_ACTION = 'Navigation Clicked'
const LINK_CLICKED_ACTION = 'Link Clicked'
const PROMOTION_VIEWED_ACTION = 'Promotion Viewed'
const PROMOTION_CLICKED_ACTION = 'Promotion Clicked'

// NavigationDetail labels
const FIND_YOUR_DOMAIN = 'Find your domain'
const CREATE_YOUR_OWN_LOGO = 'Create your own logo'
const UPGRADE_TO_WIX_PLUS = 'Upgrade to WIX Plus'
const HOW_TO_CREATE_A_WEBSITES_FOR_YOUR_BUSINESS = 'How to create a website for your business'
const SMALL_BUSINESS_WEBSITE_DESIGN = 'Small business website design: 8 keys to success'
const SEVEN_STUNNING_WEB_DESIGN_TRENDS = '7 stunning web design trends for 2025'
const CHEAT_SHEET_FOR_SMALL_BUSINESS_SEO = 'A cheat sheet for conquering small business SEO'

export const PROMOTION_TRACKING_SPECS = {
  yelp: {
    promoId: 'yelpBanner:Websites Product Page',
    creative: 'Yelp Promo Banner',
    name: 'yelpBanner',
    position: WebsitesPageZones.TakeYourBusinessFurther,
    section: TAKE_YOUR_BUSINESS_FURTHER__DATA_SECTION_LABEL,
    stage: 'Discover',
    pageName: 'Websites (TBYB):Product Page',
  },
}

export function trackMainHeroLinkClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }
  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    MAIN_HERO_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.MainHero,
    GET_STARTED_CTA_DETAIL,
  )
}

export function trackReturningMainHeroLinkClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }
  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    MAIN_HERO_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.MainHero,
    UPGRADE_CTA_DETAIL,
  )
}

export function trackSeoSectionStartForFreeLinkClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }
  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    SEO_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.SeoSection,
    GET_STARTED_CTA_DETAIL,
  )
}
export function trackPlansSectionGetStartedClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }
  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    WEBSITE_PRICING_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.WebsitePricing,
    GET_STARTED_CTA_DETAIL,
  )
}

export function trackPlansSectionFindOutMoreClick(planName: string, destinationUrl?: string) {
  if (wixPlansWebsites && destinationUrl) {
    wixPlansWebsites.pageUri = destinationUrl
  }
  // Navigates to wix plans page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    PLANS_AND_PRICING_DETAILS_LABEL,
    wixWebsites!, // source
    wixPlansWebsites!, // target
    WebsitesPageZones.WebsitePricing,
    FIND_OUT_MORE_DETAILS,
    {
      label: PLANS_AND_PRICING_DETAILS_LABEL,
      navigationDetail: planName,
      pageSection: 'Pricing',
      pageStage: 'Discover',
      pageName: 'Websites (TBYB):Product Page',
      category: 'Product Page',
      pageDept: 'Digital Marketing - Wix',
    },
  )
}

export function trackPlansSectionViewMorePlanDetailsClick(destinationUrl?: string) {
  if (wixPlansWebsites && destinationUrl) {
    wixPlansWebsites.pageUri = destinationUrl
  }
  // Navigates to wix plans page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    WEBSITE_PRICING_LABEL,
    wixWebsites!, // source
    wixPlansWebsites!, // target
    WebsitesPageZones.WebsitePricing,
    VIEW_MORE_PLAN_DETAILS,
    {
      pageSection: 'Pricing',
    },
  )
}

export function trackMainHeroPlansDetailsLinkClick(destinationUrl: string) {
  if (wixPlansBusiness && destinationUrl) {
    wixPlansBusiness.pageUri = destinationUrl
  }
  // Navigates to wix plans page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    PLAN_DETAILS_LABEL,
    wixWebsites!, // source
    wixPlansBusiness!, // target
    WebsitesPageZones.MainHero,
    PLANS_CTA_DETAIL,
  )
}

export function trackSecondHeroLinkClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }

  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    SECOND_HERO_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.SecondHero,
    GET_STARTED_CTA_DETAIL,
  )
}

export function trackPlansDetailsLinkClick(destinationUrl: string) {
  if (wixPlansBusiness && destinationUrl) {
    wixPlansBusiness.pageUri = destinationUrl
  }
  // Navigates to wix plans page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    PLAN_DETAILS_LABEL,
    wixWebsites!, // source
    wixPlansBusiness!, // target
    WebsitesPageZones.PlanDetails,
    PLANS_CTA_DETAIL,
  )
}

export function trackTemplatesLinkClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }
  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    TEMPLATES_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.Templates,
    GET_STARTED_CTA_DETAIL,
  )
}

export function trackTemplateViewSimilarLinkClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }
  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    TEMPLATES_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.Templates,
    VIEW_SIMILAR_CTA_DETAIL,
  )
}

export function trackTemplateEditThisTemplateLinkClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }
  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    TEMPLATES_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.Templates,
    EDIT_THIS_TEMPLATE_CTA_DETAIL,
  )
}

export function trackThirdHeroLinkClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }
  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    THIRD_HERO_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.ThirdHero,
    GET_STARTED_CTA_DETAIL,
  )
}

export function trackFourthHeroLinkClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }
  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    FOURTH_HERO_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.FourthHero,
    GET_STARTED_CTA_DETAIL,
  )
}

export function trackFreeWebsitesSectionLinkClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }
  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    FREE_WEBSITES_SECTION_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.FreeWebsitesSection,
    GET_STARTED_CTA_DETAIL,
  )
}

export function trackTemplatesIndustrySectionLinkClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }
  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    TEMPLATES_BUILT_FOR_EVERY_INDUSTRY_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.TemplatesBuiltForEveryIndustry,
    GET_STARTED_CTA_DETAIL,
  )
}

export function trackTemplateSectionSelected(selectedSectionKey: string) {
  const selectedTemplateLabel = `Content:${selectedSectionKey}`
  trackNavigationEvent(
    LINK_CLICKED_ACTION,
    selectedTemplateLabel,
    wixWebsites!, // source
    wixWebsites!, // target
    WebsitesPageZones.TemplatesBuiltForEveryIndustry,
  )
}

export function trackNavigationTabsSectionLinkClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }
  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    NAVIGATION_TABS_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.NavigationTabs,
    GET_STARTED_CTA_DETAIL,
  )
}

export function trackNavigationTabsUpgradeLinkClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) {
    wixMySites.pageUri = destinationUrl
  }
  // Navigates to wix my sites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    NAVIGATION_TABS_LABEL,
    wixWebsites!, // source
    wixMySites!, // target
    WebsitesPageZones.NavigationTabs,
    UPGRADE_WEBSITE_CTA_DETAIL,
  )
}

export function trackNavigationTabPressed(activeAnchorName: string) {
  const selectedTabLabel = `Tab Pressed:${activeAnchorName}`
  trackNavigationEvent(
    LINK_CLICKED_ACTION,
    selectedTabLabel,
    wixWebsites!, // source
    wixWebsites!, // target
    WebsitesPageZones.NavigationTabs,
  )
}

export function trackFindYourDomainLinkClick(destinationUrl: string) {
  if (wixDomains && destinationUrl) {
    wixDomains.pageUri = destinationUrl
  }
  // Navigates to Wix Domains product page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    TAKE_YOUR_BUSINESS_FURTHER_LABEL,
    wixWebsites!, // source
    wixDomains!, // target
    WebsitesPageZones.TakeYourBusinessFurther,
    GET_STARTED_CTA_DETAIL,
    { navigationDetail: FIND_YOUR_DOMAIN },
  )
}

export function trackCreateYourLogoLinkClick(destinationUrl: string) {
  if (logoMakerProductPage && destinationUrl) {
    logoMakerProductPage.pageUri = destinationUrl
  }
  // Navigates to Logo Maker product page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    TAKE_YOUR_BUSINESS_FURTHER_LABEL,
    wixWebsites!, // source
    logoMakerProductPage!, // target
    WebsitesPageZones.TakeYourBusinessFurther,
    START_CREATING_CTA_DETAIL,
    { navigationDetail: CREATE_YOUR_OWN_LOGO },
  )
}

export function trackUpgradeToWixPlusLinkClick(destinationUrl: string) {
  if (diwyProductPage && destinationUrl) {
    diwyProductPage.pageUri = destinationUrl
  }
  // Navigates to Wix Plus product page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    TAKE_YOUR_BUSINESS_FURTHER_LABEL,
    wixWebsites!, // source
    diwyProductPage!, // target
    WebsitesPageZones.TakeYourBusinessFurther,
    GET_STARTED_CTA_DETAIL,
    { navigationDetail: UPGRADE_TO_WIX_PLUS },
  )
}

export function trackCarouselSlidePromotionClick(trackingSpec: any) {
  trackPromotionEvent(
    PROMOTION_CLICKED_ACTION, // action
    trackingSpec.promoId,
    trackingSpec.creative,
    trackingSpec.name,
    trackingSpec.position,
    trackingSpec.section,
    trackingSpec.stage,
    trackingSpec.pageName,
  )
}

export function trackCarouselSlidePromotionViewed(trackingSpec: any) {
  trackPromotionEvent(
    PROMOTION_VIEWED_ACTION,
    trackingSpec.promoId,
    trackingSpec.creative,
    trackingSpec.name,
    trackingSpec.position,
    trackingSpec.section,
    trackingSpec.stage,
    trackingSpec.pageName,
  )
}

export function trackYelpLinkClick() {
  trackCarouselSlidePromotionClick(PROMOTION_TRACKING_SPECS.yelp)
}

export function useTrackOnComponentView(trackingSpecs?: any) {
  if (trackingSpecs === undefined || trackingSpecs === null) {
    return
  }
  const ref = useRef(null)
  const wasTracked = useRef(false) // Prevent duplicate tracking
  useEffect(() => {
    const element = ref.current
    if (!element) {
      return
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !wasTracked.current) {
          wasTracked.current = true
          trackCarouselSlidePromotionViewed(trackingSpecs)
          observer.disconnect()
        } else {
          wasTracked.current = false
        }
      },
      { threshold: 0.5 },
    )
    observer.observe(element)
    return () => {
      if (element) {
        observer.disconnect()
      }
    }
  }, [trackingSpecs])

  return ref
}

export function trackHowToCreateWebsiteLinkClick(destinationUrl: string) {
  // Navigates to "How to create a website for your business" article
  const articleLearnMoreDestination = {
    pageUri: destinationUrl.split('?')[0],
  }
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    IDEAS_AND_ADVICE_LABEL,
    wixWebsites!, // source
    articleLearnMoreDestination, // target
    WebsitesPageZones.IdeasAndAdvice,
    READ_MORE_CTA_DETAIL,
    { navigationDetail: HOW_TO_CREATE_A_WEBSITES_FOR_YOUR_BUSINESS },
  )
}
export function trackSmallBusinessWebsiteDesignLinkClick(destinationUrl: string) {
  // Navigates to "Small business website design: 8 keys to success" article
  const articleLearnMoreDestination = {
    pageUri: destinationUrl.split('?')[0],
  }
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    IDEAS_AND_ADVICE_LABEL,
    wixWebsites!, // source
    articleLearnMoreDestination, // target
    WebsitesPageZones.IdeasAndAdvice,
    READ_MORE_CTA_DETAIL,
    { navigationDetail: SMALL_BUSINESS_WEBSITE_DESIGN },
  )
}

export function trackSevenWebDesignTrendsLinkClick(destinationUrl: string) {
  // Navigates to "7 stunning web design trends for 2025" article
  const articleLearnMoreDestination = {
    pageUri: destinationUrl.split('?')[0],
  }
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    IDEAS_AND_ADVICE_LABEL,
    wixWebsites!, // source
    articleLearnMoreDestination, // target
    WebsitesPageZones.IdeasAndAdvice,
    READ_MORE_CTA_DETAIL,
    { navigationDetail: SEVEN_STUNNING_WEB_DESIGN_TRENDS },
  )
}

export function trackCheatSheetForBusinessSeoLinkClick(destinationUrl: string) {
  // Navigates to "A cheat sheet for conquering small business SEO" article
  const articleLearnMoreDestination = {
    pageUri: destinationUrl.split('?')[0],
  }
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    IDEAS_AND_ADVICE_LABEL,
    wixWebsites!, // source
    articleLearnMoreDestination, // target
    WebsitesPageZones.IdeasAndAdvice,
    READ_MORE_CTA_DETAIL,
    { navigationDetail: CHEAT_SHEET_FOR_SMALL_BUSINESS_SEO },
  )
}

// Banner Scenarios (Returning Customers PDP)
const RETURNING_CUSTOMERS_BANNER_LABEL = 'Content:Returning Customer Banner'

export function trackBannerEditSiteClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) wixMySites.pageUri = destinationUrl
  trackNavigationEvent(NAVIGATION_CLICKED_ACTION, RETURNING_CUSTOMERS_BANNER_LABEL, wixWebsites!, wixMySites!, 'Returning Customer Banner', 'Edit Site')
}

export function trackBannerViewSiteClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) wixMySites.pageUri = destinationUrl
  trackNavigationEvent(NAVIGATION_CLICKED_ACTION, RETURNING_CUSTOMERS_BANNER_LABEL, wixWebsites!, wixMySites!, 'Returning Customer Banner', 'View Site')
}

export function trackBannerConnectDomainClick(destinationUrl: string) {
  if (wixDomains && destinationUrl) wixDomains.pageUri = destinationUrl
  trackNavigationEvent(NAVIGATION_CLICKED_ACTION, RETURNING_CUSTOMERS_BANNER_LABEL, wixWebsites!, wixDomains!, 'Returning Customer Banner', 'Connect Domain')
}

export function trackBannerViewDashboardClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) wixMySites.pageUri = destinationUrl
  trackNavigationEvent(LINK_CLICKED_ACTION, RETURNING_CUSTOMERS_BANNER_LABEL, wixWebsites!, wixMySites!, 'Returning Customer Banner', 'View Dashboard')
}

export function trackBannerCreateWebsiteClick(destinationUrl: string) {
  if (wixMySites && destinationUrl) wixMySites.pageUri = destinationUrl
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    RETURNING_CUSTOMERS_BANNER_LABEL,
    wixWebsites!,
    wixMySites!,
    'Returning Customer Banner',
    GET_STARTED_CTA_DETAIL,
  )
}
